import React from "react";
import DashboardWorldMap from "../../../../components/charts/DashboardWorldMap";

export default function WidgetParticipantsMap({
  participants,
  worldMapInfo,
  onWorldMapInfoChange,
}) {
  return (
    <div className="box box-solid bg-blue-map">
      
      <div className="box-body">
        <DashboardWorldMap
          key={participants}
          participants={participants}
          callback={(countryCode, value) => onWorldMapInfoChange(`${countryCode} : ${value} participants`)}
        />
      </div>
      <div className="" style={{padding: "0px 5px"}}>
        <p className="color-dark">{worldMapInfo}</p>
      </div>
    </div>
  );
}
